import React, { useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import usePrivate from '@afosto/auth-react/usePrivate';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import Page from '@afosto/app-components-react/Page';
import ApplicationOverview from './ApplicationOverview';
import BillingInformation from './BillingInformation';
import PurgeRequestDialog from './PurgeRequestDialog';
import translations from './translations';

const Contract = () => {
  usePrivate();
  const [hasPermissions] = usePermissions(['iam:subscriptions:read']);

  const history = useHistory();
  const intl = useIntl();
  const location = useLocation();
  const [showPurgeRequestDialog, setShowPurgeRequestDialog] = useState(false);

  return (
    <>
      <Page
        title={intl.formatMessage(translations.title)}
        subNavigation={{
          current: location.pathname,
          tabs: [
            {
              label: intl.formatMessage(translations.subNavigation.overview),
              path: '/contract',
            },
            {
              label: intl.formatMessage(translations.subNavigation.invites),
              path: '/contract/billing',
            },
          ],
          onChange: (e, value) => history.replace(value),
        }}
        secondaryActions={[
          ...(hasPermissions(['iam:tenants:read'])
            ? [
                {
                  key: 'requestPurge',
                  text: intl.formatMessage(translations.secondaryActions.requestPurge),
                  action: () => setShowPurgeRequestDialog(true),
                  color: 'secondary',
                },
              ]
            : []),
        ]}
      >
        <Switch>
          <Route path="/contract/billing" component={BillingInformation} />
          <Route path="/contract" component={ApplicationOverview} />
        </Switch>
      </Page>
      <PurgeRequestDialog
        isOpen={showPurgeRequestDialog}
        onClose={() => setShowPurgeRequestDialog(false)}
      />
    </>
  );
};

export default Contract;
